import React, { FC, useContext, useEffect, useState } from "react";
//import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";


//import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import FooterNav from "components_custom/FooterNav/FooterNav";

import { requestAPI } from "utils/api";
import { GlobalDataContext } from "contexts/GlobalData";
import ReservationHead from "./ReservationHead";
import SigninForm from "components_custom/SigninForm/SigninForm";
import ReservationCard from "./ReservationCard";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
  posts?: PostDataType[];
  className?: string;
  postCardName?: "card3";
}



const Reservation: FC<SectionLatestPostsProps> = ({
  posts = postsDemo,
  postCardName = "card3",
  className = "",
}) => {

	const [list, setList] = useState <[]> ([]);

	const { 
		initData,
	} = useContext (GlobalDataContext);

	useEffect (() => {
		(async () => {

			if (initData.token_info.permission_group !== "guest") {
				const res: any = await requestAPI('GET', `v1/reserve/me`, null);
				console.log('r1', res);
				setList(res.data.list);
			}
		})();
		
	}, []);

	const emptyList = () => {
		return (
			<main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
				<div className="text-center">
					<p className="text-base font-semibold text-indigo-600">안내</p>
					<h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">예약된 상품이 없어요</h1>
					
				
				</div>
			</main>
		)
	}

	

	return (
	<>
		
		<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>
      
			<div className="flex flex-col lg:flex-row">
				<div className="w-full pl-4 pr-4">
					
					<div className="mt-5" />
					
					{(initData.token_info.permission_group === "guest")
						?
							<>
								<ReservationHead />
								<div className="max-w-md mx-auto space-y-6 mt-[100px]">
									<SigninForm />
								</div>
							</>
						:
							<>
								<ReservationHead />
								<div className="">
									{list.length > 0
									?
										list.map((item: any, idx: number) => {

											return (
												<ReservationCard key={item._id} data={item}/>
											)
										})
									:
										emptyList()
									}
								</div>
							</>
						}
					<div className="mt-[100px]" />
				</div>
			</div>
			
			<FooterNav />
		</div>
	</>
	);
};

export default Reservation;
